<template>
    <div class="d-flex flex-row">
        <DeviceSettingsHistoryModal :history_id="machine.history_id" :patient_id="machine.patient_id" />
        <DeviceSettings
            :settings="current" :history_id="machine.history_id" :patient_id="machine.patient_id" :edit_allowed="machine.edit_allowed"
            :show_history="machine.history_size > 0" :show_edit="machine.is_assigned_to_patient"
            :user_org="user_org" :patient_org="patient_org" :auth_user="auth_user" />

        <div v-if="NoCurrentSettingsFound">
            <NoDeviceSettings :settings="pending" :machine="machine" :user_org="user_org" :patient_org="patient_org" :auth_user="auth_user" />
        </div>
        <div v-else>
            <DeviceSettings v-show="showPending"
                :settings="pending" :current="current" :history_id="machine.history_id" :patient_id="machine.patient_id"
                :user_org="user_org" :patient_org="patient_org" :auth_user="auth_user" />

        </div>
    </div>
</template>

<script setup>
import DeviceSettings from "./DeviceSettings.vue";
import DeviceSettingsHistoryModal from "./DeviceSettingsHistoryModal.vue";
import NoDeviceSettings from "../devices/NoDeviceSettings.vue";
import {computed, onMounted, ref, watch} from "vue";

const props = defineProps({
    machine: {
        type: Object,
        required: true,
    },
    user_org: {
        type: [Object, null],
        required: true,
    },
    patient_org: {
        type: Object,
        required: false,
    },
    auth_user: {
        type: [Object, null],
        required: true,
    }
});

const NoCurrentSettingsFound = ref(false);
const showPending = ref(false);

const current = ref(null);
const pending = ref(null);

const currentUri = computed(() => '/api/patients/' + props.machine.patient_id + '/devices/' + props.machine.history_id + '/current_settings')
const pendingUri = computed(() => '/api/patients/' + props.machine.patient_id + '/devices/' + props.machine.history_id + '/pending_settings')

onMounted(fetchDeviceSettings);
watch(() => props.machine.history_id, fetchDeviceSettings);

function fetchDeviceSettings() {
    NoCurrentSettingsFound.value = false;
    showPending.value = false;

    current.value = null;
    axios.get(currentUri.value).then((res) => {
        if( res.status === 200 && res.data.data && Object.keys(res.data.data).length > 0 ) {
            current.value = res.data.data;
        }
        else {
            current.value = null;
            NoCurrentSettingsFound.value = true;
        }
    })

    pending.value = null;
    axios.get(pendingUri.value).then((res) => {
        if( res.status === 200 && res.data.data && Object.keys(res.data.data).length > 0 ) {
            pending.value = res.data.data;
            showPending.value = true;
        }
        else {
            pending.value = null;
        }
    })
}
</script>
